import { CalculatedFees } from '@/apis/payments/requests'
import { PaymentType } from '@/schemas/payments.schema'

// Create a branded type for more precise type checking
export type ApplicantPaymentAmount = number & {
  readonly __brand: unique symbol
}

// Helper function to cast the number to the branded type
function asApplicantPaymentAmount(amount: number): ApplicantPaymentAmount {
  return amount as ApplicantPaymentAmount
}

export function getTotalAmountToBePaidByApplicant(
  paymentInformation: CalculatedFees
): ApplicantPaymentAmount {
  const { base_amount, net_amount, serviceFeePayer } = paymentInformation

  if (serviceFeePayer === 'Applicant') {
    return asApplicantPaymentAmount(net_amount)
  }

  return asApplicantPaymentAmount(base_amount)
}

export function displayTotalAmountToBePaidByApplicant(
  paymentInformation: CalculatedFees,
  paymentType: PaymentType
): ApplicantPaymentAmount {
  if (paymentType === 'Reimbursement') {
    return asApplicantPaymentAmount(paymentInformation.net_amount)
  }

  const amount = getTotalAmountToBePaidByApplicant(paymentInformation)
  return amount
}
